import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const useFormStatutorydoc = () => {
  const { token } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("businessRegistration", formData.businessRegistration);
      formDataToSend.append("financialStatement", formData.financialStatement);
      formDataToSend.append("companyProfile", formData.companyProfile);
      formDataToSend.append("itf", formData.itf);
      formDataToSend.append("nitf", formData.nitf);
      // formDataToSend.append("signature", formData.signature); 

      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/charterer/profile/upload/statutoryDocs`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      const resData = await res.json();

      if (!res.ok) {
        throw new Error(resData.message);
      }

      setLoading(false);
      setSuccess("Files uploaded successfully");
      setTimeout(() => {
        setSuccess(false);
        navigate("/license");
      }, 3000);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    loading,
    error,
    success,
  };
};

export default useFormStatutorydoc;

